import { atom } from "recoil";
import { Exhibitor } from "../models";

const KEY = "app-exhibitors";

export const appExhibitors = atom<Exhibitor[] | null>({
    key: KEY,
    default: null,
});
